<template>
    <article class="project-card" @click="gotoProject(project)">
        <div class="project-card__head">
            <div class="project-card__head-main">
                <div class="project-card__name">{{ project.name }}</div>
                <div
                    class="project-card__status"
                    :class="project.isOnBoardingActive ? 'project-card__status--wait' : 'project-card__status--on'"
                >
                    <svg
                        v-if="project.isOnBoardingActive"
                        viewBox="0 0 16 16"
                        fill="none"
                        aria-hidden="true"
                    >
                        <circle cx="8" cy="8" r="7" fill="#E0473A" />
                        <path d="M8 4.4v4.2" stroke="#fff" stroke-width="1.6" stroke-linecap="round" />
                        <circle cx="8" cy="11.2" r=".9" fill="#fff" />
                    </svg>
                    <svg v-else viewBox="0 0 16 16" fill="none" aria-hidden="true">
                        <circle cx="8" cy="8" r="7" fill="#1E9E5A" />
                        <path
                            d="M5 8.2l2 2 4-4.4"
                            stroke="#fff"
                            stroke-width="1.6"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                    {{ project.isOnBoardingActive ? 'Ждёт настроек' : 'Активный' }}
                </div>
            </div>
            <div class="project-card__actions" @click.stop>
                <v-btn v-if="false" icon class="marketplace-btn">
                    <v-img
                        contain
                        height="24"
                        transition="slide-x-transition"
                        :src="require('@/assets/icons/marketplace-icon.svg')"
                        alt="Marketplace"
                        @click.stop="goToMarket(project.id)"
                    />
                </v-btn>
                <v-menu :close-on-content-click="true" offset-y left>
                    <template v-slot:activator="{ on, attrs }">
                        <button
                            v-if="someActionsAvailable"
                            v-bind="attrs"
                            v-on="on"
                            type="button"
                            class="project-card__menu-btn"
                            aria-label="Действия с проектом"
                        >
                            <v-icon size="20">mdi-dots-vertical</v-icon>
                        </button>
                    </template>
                    <v-card min-width="198px">
                        <v-list>
                            <v-list-item
                                class="text-btn-wrapper"
                                @click="addUser()"
                                :disabled="!checkAccess(project.id, 'owner')"
                            >
                                <span class="mx-3 my-2">Добавить пользователя</span>
                            </v-list-item>
                            <v-list-item
                                v-if="isTester"
                                class="text-btn-wrapper"
                                @click="deleteProject()"
                                :disabled="!checkRole(project.id, 'project:delete')"
                            >
                                <span class="mx-3 my-2">Удалить проект</span>
                            </v-list-item>
                            <v-list-item
                                class="text-btn-wrapper"
                                @click="renameProject()"
                                :disabled="!checkRole(project.id, 'project:rename')"
                            >
                                <span class="mx-3 my-2">Переименовать</span>
                            </v-list-item>
                        </v-list>
                    </v-card>
                </v-menu>
            </div>
        </div>
        <div class="project-card__image-wrap">
            <button
                v-if="checkRole(project.id, 'project:changeImage')"
                type="button"
                class="project-card__edit-image"
                @click.stop="changeProjectImage"
                aria-label="Изменить изображение проекта"
            >
                <v-icon color="white" size="18">mdi-pencil</v-icon>
            </button>
            <v-img
                v-if="!project.image"
                height="150"
                contain
                src="@/assets/img/project-image.svg"
            ></v-img>
            <v-img v-else height="150" cover :src="project.image.src"></v-img>
        </div>
        <div class="project-card__foot">
            <div class="project-card__foot-label">Доступен:</div>
            <div class="project-card__avs">
                <template v-for="user in displayProject.available">
                    <span v-if="!user.isPending" :key="user.id" class="project-card__av">
                        <v-img transition="slide-x-transition" :src="user.avatar" :alt="user.email" />
                    </span>
                    <span v-else :key="user.id" class="project-card__av project-card__av--pending">
                        <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                            <circle cx="12" cy="8" r="4" />
                            <path d="M4 21a8 8 0 0116 0z" />
                        </svg>
                    </span>
                </template>
                <span v-if="displayProject.avatarsDelete > 0" class="project-card__more">
                    +{{ displayProject.avatarsDelete }}
                </span>
            </div>
        </div>
    </article>
</template>

<script>
import { checkAccess } from '@/utils'
import { checkRole } from '@root/src/helpers/roles'
import cfg from '../../../config'
const VISIBLE_AVATARS = 5
export default {
    name: 'ProjectCard',
    props: {
        project: {
            type: Object,
            default: () => ({}),
        },
    },
    components: {},
    computed: {
        displayProject() {
            const users = this.project.users || []
            return {
                available: users.slice(0, VISIBLE_AVATARS),
                avatarsDelete: Math.max(0, users.length - VISIBLE_AVATARS),
            }
        },
        someActionsAvailable() {
            return (
                this.checkAccess(this.project.id, 'owner') ||
                checkRole(this.project.id, 'project:delete') ||
                checkRole(this.project.id, 'project:rename')
            )
        },
        isTester() {
            return cfg.testerEmails.includes(this.$auth.user.email)
        },
    },
    methods: {
        checkAccess,
        checkRole,
        addUser() {
            this.$parent.$emit('addUser', this.project.id)
        },
        gotoProject(project) {
            const onboardingActive = project.isOnBoardingActive
            if (onboardingActive) this.$router.push(`/project/${project.id}/onBoarding`)
            else this.$router.push(`/project/${project.id}`)
        },
        deleteProject() {
            this.$parent.$emit('deleteProject', this.project.id)
        },
        renameProject() {
            this.$parent.$emit('renameProject', this.project.id)
        },
        changeProjectImage() {
            this.$parent.$emit('changeProjectImage', this.project.id)
        },
        goToMarket(projectId) {
            this.$router.push(`/project/${projectId}/marketplace`)
        },
    },

}
</script>

<style lang="sass" scoped>
@import '@/vars.sass'

.project-card
    background: #fff !important
    border: 1px solid #E6E9F0
    border-radius: 14px
    overflow: hidden
    box-shadow: 0 1px 2px rgba(26, 26, 46, .04)
    display: flex
    flex-direction: column
    min-width: 0
    width: 100%
    cursor: pointer
    transition: transform .15s, box-shadow .15s, border-color .15s

    &:hover
        transform: translateY(-1px)
        box-shadow: 0 8px 20px rgba(26, 26, 46, .08)
        border-color: #D6DCE8

.project-card__head
    display: flex
    align-items: flex-start
    justify-content: space-between
    gap: 8px
    padding: 17px 12px 15px 20px
    background: #fff !important

.project-card__head-main
    min-width: 0
    flex: 1

.project-card__name
    font-family: $font-family-base !important
    font-size: 17px !important
    font-weight: 800 !important
    letter-spacing: -.02em
    line-height: 1.25
    color: $dark-new !important
    white-space: nowrap
    overflow: hidden
    text-overflow: ellipsis

.project-card__status
    display: flex
    align-items: center
    gap: 7px
    margin-top: 8px
    font-family: $font-family-base !important
    font-size: 13px !important
    font-weight: 600 !important
    line-height: 1.2

    svg
        width: 16px
        height: 16px
        flex-shrink: 0

    &--on
        color: #1E9E5A !important

    &--wait
        color: #E0473A !important

.project-card__actions
    display: flex
    align-items: flex-start
    flex-shrink: 0
    margin-top: -4px

.project-card__menu-btn
    display: inline-flex
    align-items: center
    justify-content: center
    width: 32px
    height: 32px
    padding: 0
    border: none
    border-radius: 8px
    background: transparent
    color: $muted-new !important
    cursor: pointer
    transition: background .15s, color .15s

    &:hover
        background: #EFF1F6
        color: $dark-new !important

    &:focus-visible
        outline: 2px solid rgba($main-new, .35)
        outline-offset: 1px

    ::v-deep .v-icon
        color: inherit !important

.project-card__image-wrap
    height: 150px
    position: relative
    background: $main-new
    display: flex
    align-items: center
    justify-content: center
    overflow: hidden
    flex-shrink: 0

    ::v-deep .v-image
        width: 100%
        height: 100%

.project-card__edit-image
    position: absolute
    z-index: 2
    right: 16px
    top: 16px
    width: 32px
    height: 32px
    border: none
    border-radius: 50%
    background: rgba(42, 59, 81, .14)
    display: inline-flex
    align-items: center
    justify-content: center
    cursor: pointer
    padding: 0
    transition: background .15s

    &:hover
        background: rgba(42, 59, 81, .28)

.project-card__foot
    padding: 15px 20px 18px
    margin-top: auto
    background: #fff !important

.project-card__foot-label
    font-family: $font-family-base !important
    font-size: 13px !important
    font-weight: 400 !important
    color: $muted-new !important
    margin-bottom: 11px
    line-height: 1.2

.project-card__avs
    display: flex
    align-items: center
    min-height: 34px

.project-card__av
    width: 34px
    height: 34px
    border-radius: 50%
    border: 2.5px solid #fff
    display: flex
    align-items: center
    justify-content: center
    overflow: hidden
    flex-shrink: 0
    margin-left: -9px
    background: #AAB2C4
    color: #fff !important

    &:first-child
        margin-left: 0

    &--pending
        background: #7C5CFF
        color: #fff !important

    svg
        width: 18px
        height: 18px

    ::v-deep .v-image
        width: 100%
        height: 100%

.project-card__more
    margin-left: 7px
    background: #EFF1F6
    color: $muted-new !important
    border-radius: 999px
    padding: 0 11px
    height: 27px
    display: inline-flex
    align-items: center
    font-family: $font-family-base !important
    font-weight: 700 !important
    font-size: 12px !important
    line-height: 1
    flex-shrink: 0

button:focus
    outline: 0
</style>
